/**
 * Built-in case type definitions, grouped by category.
 * The backend accepts any string as case_type (VARCHAR),
 * so clients can also use custom values not listed here.
 */

export const CASE_TYPE_GROUPS = [
  {
    label: 'Criminal',
    types: [
      { value: 'dui', label: 'DUI / DWI' },
      { value: 'felony_assault', label: 'Felony Assault' },
      { value: 'drug_possession', label: 'Drug Possession' },
      { value: 'drug_trafficking', label: 'Drug Trafficking' },
      { value: 'theft', label: 'Theft / Larceny' },
      { value: 'domestic_violence', label: 'Domestic Violence' },
      { value: 'burglary', label: 'Burglary' },
      { value: 'robbery', label: 'Robbery' },
      { value: 'homicide', label: 'Homicide' },
      { value: 'sexual_assault', label: 'Sexual Assault' },
      { value: 'fraud', label: 'Fraud / White Collar' },
      { value: 'weapons', label: 'Weapons Offense' },
      { value: 'arson', label: 'Arson' },
      { value: 'juvenile', label: 'Juvenile' },
      { value: 'federal_criminal', label: 'Federal Criminal' },
    ],
  },
  {
    label: 'Civil',
    types: [
      { value: 'personal_injury', label: 'Personal Injury' },
      { value: 'medical_malpractice', label: 'Medical Malpractice' },
      { value: 'product_liability', label: 'Product Liability' },
      { value: 'employment', label: 'Employment / Labor' },
      { value: 'contract_dispute', label: 'Contract Dispute' },
      { value: 'real_estate', label: 'Real Estate / Property' },
      { value: 'intellectual_property', label: 'Intellectual Property' },
      { value: 'class_action', label: 'Class Action' },
      { value: 'insurance', label: 'Insurance Dispute' },
      { value: 'civil_rights', label: 'Civil Rights' },
    ],
  },
  {
    label: 'Family / Other',
    types: [
      { value: 'family', label: 'Family / Custody' },
      { value: 'immigration', label: 'Immigration' },
      { value: 'bankruptcy', label: 'Bankruptcy' },
      { value: 'administrative', label: 'Administrative / Regulatory' },
      { value: 'other', label: 'Other' },
    ],
  },
];

/** Flat list of all built-in case types. */
export const CASE_TYPES = CASE_TYPE_GROUPS.flatMap(g => g.types);

/** Lookup label for a case type value (built-in or custom). */
export function caseTypeLabel(value) {
  if (!value) return 'Other';
  const found = CASE_TYPES.find(t => t.value === value);
  if (found) return found.label;
  // Custom value — humanize the snake_case string
  return value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
